import { CheckCheck } from "lucide-react";
import { ShareAppLink } from "@/components/ShareApp";

export default function EmptyState({
  title = "Nothing on the list.",
  subtitle = "Add your first big task above — we'll help break it down into bite-sized steps.",
  showShare = true,
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center" data-testid="empty-state">
      <div className="w-32 h-32 border border-zinc-200 flex items-center justify-center">
        <CheckCheck className="w-12 h-12 text-zinc-300" strokeWidth={1.2} />
      </div>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500 mt-6">
        All clear
      </p>
      <h3 className="text-2xl font-medium tracking-tight text-zinc-900 mt-2">{title}</h3>
      <p className="text-sm text-zinc-500 mt-2 max-w-xs">{subtitle}</p>
      {showShare && (
        <div className="mt-8">
          <ShareAppLink
            medium="empty_state"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.12em] font-medium text-zinc-500 hover:text-[#002FA7] transition-colors"
          >
            Know someone who'd love this? Share BreakItDown →
          </ShareAppLink>
        </div>
      )}
    </div>
  );
}
